/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortalLinkTokenRequest
 */
export interface PortalLinkTokenRequest {
    /**
     * 
     */
    token: string;
}

/**
 * Check if a given object implements the PortalLinkTokenRequest interface.
 */
export function instanceOfPortalLinkTokenRequest(value: object): value is PortalLinkTokenRequest {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function PortalLinkTokenRequestFromJSON(json: any): PortalLinkTokenRequest {
    return PortalLinkTokenRequestFromJSONTyped(json, false);
}

export function PortalLinkTokenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalLinkTokenRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function PortalLinkTokenRequestToJSON(json: any): PortalLinkTokenRequest {
    return PortalLinkTokenRequestToJSONTyped(json, false);
}

export function PortalLinkTokenRequestToJSONTyped(value?: PortalLinkTokenRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
    };
}

